<template>
  <div>
    <h3 v-if="title" class="h3">{{ title }}</h3>
    <div v-if="description" class="my-2">{{ description }}</div>
  </div>
</template>
<script>
export default {
  name: "TituloPaginas",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>
